<template>
  <div class="business-submenu">
    <div
      class="open-submenu"
      @click="toggleBusinessSubmenu">
      <span class="logo">
        <span
          :style="merchantLogo ? `background-image: url(${merchantLogo})` : ''"
          class="image"/>
        <span
          :class="{ green: merchantSettings.available, red: !merchantSettings.available }"
          class="indicator"/>
      </span>
      <span class="name">{{ merchantName }}</span>
      <span
        :class="{opened: businessSubmenuOpened}"
        class="arrow">
        <icon name="chevron-down"/>
      </span>
    </div>
    <ul
      v-show="businessSubmenuOpened"
      class="mobile-menu-list">
      <li class="list-item change-status">
        <div
          class="mobile-menu-availability clearfix">
          <label for="business-availability">
            <span
              :class="{ green: merchantSettings.available, red: !merchantSettings.available }"
              class="indicator"/>
            {{ merchantSettings.available ? 'Available' : 'Away' }}
          </label>
          <SwitchCheckbox
            id="business-availability"
            v-model="merchantSettings.available"
            class="availability-check"
            size="mini"
            @input="changeMerchantAvailability"/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MerchantAvailabilityMixin from '@/mixins/MerchantAvailability';
import SwitchCheckbox from '../SwitchCheckbox';

export default {
  name: 'BusinessSubmenu',
  components: {
    SwitchCheckbox,
  },
  mixins: [
    MerchantAvailabilityMixin,
  ],
  data() {
    return {
      businessSubmenuOpened: false,
    };
  },
  computed: {
    ...mapGetters({
      merchantName: 'merchant/merchantName',
      merchantLogo: 'merchant/merchantLogo',
    }),
  },
  methods: {
    toggleBusinessSubmenu() {
      this.businessSubmenuOpened = !this.businessSubmenuOpened;
    },
  },
};
</script>
